import React from 'react';
import { TextField, Typography, Select, MenuItem, InputLabel, FormControl, Box, Button } from '@mui/material';
import { regionOptions, styleOptions } from '../data/TravelOptions';
import '../Pages/RegisterForm.css';
import { shortRegionOptions } from '../data/TravelOptions';
import { Checkbox, FormControlLabel } from '@mui/material';

export default function RegisterDetailsStep({ formData, setFormData, onFinish }) {
    return (
        <Box>
            <Typography className="register-title">כמה פרטים עליך</Typography>

            <TextField
                label="מקום מגורים"
                fullWidth
                margin="normal"
                value={formData.location || ''}
                onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            />

            <TextField
                label="תחומי עניין"
                fullWidth
                margin="normal"
                value={formData.interests || ''}
                onChange={(e) => setFormData({ ...formData, interests: e.target.value })}
            />

            <FormControl component="fieldset" fullWidth margin="normal">
                <Typography variant="subtitle1" sx={{ mb: 1 }}>אני אוהב/ת לטייל באזורים...</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2 }}>
                    {shortRegionOptions.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            control={
                                <Checkbox
                                    checked={formData.favorite_trip_locations.includes(option.label)}
                                    onChange={(e) => {
                                        const newValue = e.target.checked
                                            ? [...formData.favorite_trip_locations, option.label]
                                            : formData.favorite_trip_locations.filter(val => val !== option.label);
                                        setFormData({ ...formData, favorite_trip_locations: newValue });
                                    }}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </Box>
            </FormControl>


            <FormControl fullWidth margin="normal">
                <InputLabel>סגנון טיול אהוב</InputLabel>
                <Select
                    multiple
                    value={formData.favorite_trip_styles || []}
                    onChange={(e) => setFormData({ ...formData, favorite_trip_styles: e.target.value })}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        },
                    }}
                >
                    {styleOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                label="קצת עליי"
                multiline
                rows={3}
                fullWidth
                margin="normal"
                value={formData.about || ''}
                onChange={(e) => setFormData({ ...formData, about: e.target.value })}
            />

            <Button
                className="upload-button"
                variant="outlined"
                component="label"
                fullWidth
                sx={{ mt: 2 }}
            >
                העלה תמונת פרופיל
                <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        const formDataUpload = new FormData();
                        formDataUpload.append("file", file);
                        formDataUpload.append("upload_preset", "profilePics");

                        try {
                            const res = await fetch("https://api.cloudinary.com/v1_1/dyjdd8hcc/image/upload", {
                                method: "POST",
                                body: formDataUpload,
                            });
                            const data = await res.json();
                            setFormData({ ...formData, image: data.secure_url });
                        } catch (err) {
                            console.error("Image upload failed:", err);
                        }
                    }}
                />

            </Button>

            {formData.image && (
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <img
                        src={formData.image}
                        alt="תמונת פרופיל"
                        style={{ width: '100px', borderRadius: '50%' }}
                    />
                </Box>
            )}

            <Button
                className="register-button"
                fullWidth
                variant="contained"
                sx={{ mt: 2 }}
                onClick={onFinish}
            >
                שמור
            </Button>

            <Typography
                variant="body2"
                sx={{ mt: 2, textAlign: 'center', color: 'red', fontStyle: 'italic' }}
            >
                ככל שתוסיף.י יותר פרטים – כך יגדלו הסיכויים למצוא שותפים לטיולים שמתאימים לך
            </Typography>
            <Typography
                variant="body2"
                sx={{ mt: 2, textAlign: 'center', color: 'gray', fontStyle: 'italic' }}
            >
                ניתן לשמור בכל שלב ולהמשיך למלא בהמשך דרך הפרופיל
            </Typography>

        </Box>
    );
}

